<h2 mat-dialog-title>
  Chat Settings
</h2>

<mat-dialog-content>
  <app-paper-chat-filter
    #paperChatFilter
    [projectId]="projectId"
    [showHint]="true"
    (invalid)="invalid = $event">
  </app-paper-chat-filter>
</mat-dialog-content>

<mat-dialog-actions class="actions">
  <button mat-button (click)="close()">Cancel</button>
  <span class="spacer"></span>
  <button mat-button color="primary" [disabled]="invalid" (click)="save()">Save</button>
</mat-dialog-actions>
